/* eslint-disable no-unused-vars */
import React, { useCallback, useState } from 'react';
import { Box, Button, Container, makeStyles } from '@material-ui/core';
import { Page } from 'src/components';
import {
  EcomOrdersListToolbar as Toolbar,
  PurchaseOrderListTable
} from './components';
import { LoaderBar } from 'src/components';
import { debounce } from 'lodash';
import { slices, useAppDispatch, useAppSelector } from 'src/redux';
import { Alert, Pagination } from '@material-ui/lab';
import PoSummary from './components/PoSummary';
import useUserInfo from 'src/hooks/user/use-user-info';
const {
  actions: purchaseOrderActions,
  selectors: purchaseOrderSelectors
} = slices.purchaseOrder;

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  productCard: {
    height: '100%'
  }
}));

export const component = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { isAccountingStaff } = useUserInfo();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const params = useAppSelector(purchaseOrderSelectors.selectParams);

  const totalAmount = useAppSelector(purchaseOrderSelectors.selectTotalAmount);

  const onShowList = useCallback(() => {
    dispatch(purchaseOrderActions.getPurchaseOrdersThunk(params));
  }, [dispatch, params]);
  // const paginationMeta = useAppSelector(
  //   ecomOrderSelectors.getEcomOrderPaginationMeta
  // );
  // const orderListRequest = useAppSelector(
  //   ecomOrderSelectors.getEcomOrderListRequest
  // );

  // const getEcomOrderList = debounce(async () => {
  //   setIsLoading(true);
  //   dispatch(ecomOrderActions.getEcomOrderListThunk({})).finally(() =>
  //     setIsLoading(false)
  //   );
  // }, 500);

  // const handlePageChange = (event: React.ChangeEvent<any>, value: number) => {
  //   dispatch(ecomOrderActions.updateGetEcomOrdersListRequest({ page: value }));
  //   getEcomOrderList();
  // };

  return (
    <Page className={classes.root} title="Purchase Orders">
      <Container
        maxWidth={false}
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1em'
        }}
      >
        <Toolbar />
        <PoSummary />

        <Box>
          <Alert severity="info" style={{ marginTop: '1em' }}>
            &quot;SELECT ALL&quot; button is only available when the list is
            filtered by status — except when the status is &quot;For
            Delivery&quot; or &quot;For Product In&quot;.
          </Alert>
        </Box>

        {isAccountingStaff && totalAmount !== null ? (
          <div style={{ display: 'flex' }}>
            <Button color="primary" variant="outlined" onClick={onShowList}>
              Show List
            </Button>
          </div>
        ) : null}

        <Box mt={2}>
          <LoaderBar isLoading={isLoading} />
          <PurchaseOrderListTable />
        </Box>
      </Container>
      {/* <Box display="flex" justifyContent="flex-end" p={2}>
        {(paginationMeta?.last_page || 0) > 1 ? (
          <Pagination
            count={paginationMeta?.last_page || 1}
            page={orderListRequest?.page || 1}
            onChange={handlePageChange}
          />
        ) : null}
      </Box> */}
    </Page>
  );
};

export const PurchaseOrders = React.memo(component);
